'use client';
import Icon from '@/components/elements/Icon';
import { useTranslations } from 'use-intl';
import { useState } from 'react';
import { SidebarProps } from './types';
import { iconMap } from './constants';
import { useNetwork } from '@/presentation/context/network';
import {
  SidebarHorizontalCreateLink,
  SidebarHorizontalLink,
  sidebarHorizontalLinkClasses,
} from './components/SidebarHorizontalLink';
import { SidebarHorizontalLinkIcon } from './components';

export const SidebarHorizontal = ({ activePage }: SidebarProps) => {
  const [showCreate, setShowCreate] = useState(false);
  const t = useTranslations('Sidebar');
  const { slug: chain } = useNetwork();
  const isCreateActive = 'create' === activePage;

  return (
    <div className="overflow-hidden border-t-2 h-[75px] border-gray-300 min-h-[74px] bg-gray-50 p-1.5 py-2 flex flex-row flex-1 justify-center short:hidden">
      <nav className="w-full">
        <div className="flex h-full items-center space-between pr-[5vw]">
          <ul className="flex w-full h-full space-x-2 items-center justify-evenly">
            {!showCreate ? (
              <>
                {(['profile', 'collections', 'swap', 'auctions'] as const).map(
                  (page) => (
                    <li key={page}>
                      <SidebarHorizontalLink
                        page={page}
                        isActive={page === activePage}
                      />
                    </li>
                  )
                )}
              </>
            ) : (
              <>
                {/* <SidebarHorizontalCreateLink
                  href={`/${chain}/create/vault`}
                  title={t('newVault')}
                /> */}
                <SidebarHorizontalCreateLink
                  href={`/${chain}/create/position`}
                  title={t('newPosition')}
                />
              </>
            )}
          </ul>

          <span
            className={sidebarHorizontalLinkClasses(isCreateActive)}
            onClick={() => setShowCreate(!showCreate)}
          >
            <SidebarHorizontalLinkIcon
              icon={iconMap.create}
              isActive={isCreateActive}
              iconSize={showCreate ? 32 : undefined}
              className={`relative ${showCreate ? 'top-[3px] rotate-45' : ''}`}
            />
            <span
              className={`${
                showCreate ? 'h-0' : 'h-[16px]'
              } overflow-hidden duration-200 transition-all`}
            >
              {t('create')}
            </span>
          </span>
        </div>
      </nav>
    </div>
  );
};

export default SidebarHorizontal;
